import React, {useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {
  ModeleAdresseDepot,
  ModeleClient,
  ModeleClientDemande,
  modeleClientDemandeInitValues,
  modeleClientInitValues,
  ModeleEditCentre,
  ModeleEditEquipe,
} from '../../../../components/Models'
import moment from 'moment'
import {extractedHour, renderIconSource, renderStatut} from '../../../../components/renders'
import {Pagination} from '../../../../components/Pagination'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {useAuth} from '../../../modules/auth'
import {
  getDemandeFlagColor,
  loadFilters,
  saveFilters,
  shouldDisplayFonctionnalite,
} from '../../../../components/helpers'
import {useFormik} from 'formik'
import {
  changeClientOnDemande,
  createClient,
  deleteDemande,
  getAdresseDepotBySourceDemande,
  getAllDelaisTraitement,
  getCentreAll,
  getClient,
  getClientDemandeEtape,
  getClientDemandeImmat,
  getCountByState,
  getDemandeProposee,
  getDemandes,
  getDemandeSource,
  getEquipeUtilisateur,
  getMesActions,
  getProvenancePiece,
} from '../../../../components/requests'
import ResearchVehicleModal from '../Components/ResearchVehicleModal'
import AddClientModal from '../Components/AddClientModal'
import ResearchClientModal from '../Components/ResearchClientModal'
import 'react-toastify/dist/ReactToastify.css'
import {useLocation} from 'react-router'
import {Tooltip} from 'react-tooltip'
import TableFilter from '../Components/TableFilter'
import InfoLigne from '../Components/InfoLigne'
import ClientDemandeMessage from '../../suggestion/Components/ClientDemandeMessage'
import ChoixContactModal from '../Components/ChoixContactModal'
import {ViewActionModal} from '../../mesActions/ViewActionModal'
import {ShopModal} from '../Components/shop/ShopModal'
import IconCalendar from '../../../../components/icon/IconCalendar'
import IconHour from '../../../../components/icon/IconHour'
import InfoCard from '../Components/InfoCard'
import axios from 'axios'
import ConfirmVBModal from '../Components/ConfirmVBModal'
import ModalPOT from '../Components/Televendeur/ModalPOT'
import {useFilAriane} from '../../../contexts/FilArianeContext'
import DemandeSearchFilter from '../Components/DemandeSearchFilter'
import styles from '../../../../components/Loader.module.css'
import {useNavigate} from 'react-router-dom'
import isEqual from 'lodash/isEqual'
import TempsEcoule from '../Components/TempsEcoule'
import {Modal} from "bootstrap";

const DemandListPage = (props) => {
  const {SelectedClient, isPro, isFromClient, isFromModalClient} = props
  const location = useLocation()
  const state = location.state as LocationState | null
  const [data, setData] = useState<Array<ModeleClientDemande>>([])
  const [, setLoading] = useState(true)
  const [trigger, setTrigger] = useState(0)
  const [clientId, setClientId] = useState<number | null>(null)
  const [isCreateViaModal, setIsCreateViaModal] = useState<boolean>(false)
  const [openModalResVeh, setOpenModalResVeh] = useState<boolean>(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const {currentUser} = useAuth()
  const [initial] = useState(() => loadFilters()) // Venant du filtre temporaire
  const [clientDemandeEtape, setclientDemandeEtape] = useState<any | undefined>([])
  const [searchPage, setSearchPage] = useState<any>(initial?.searchPage ?? '')
  const [searchId, setSearchId] = useState<any>(initial?.searchId ?? '')
  const TRI_KEYS_TABLE_HEADER: string[] = [
    'ASSIGN',
    'DATE',
    'DELAI',
    'STATUT',
    'CANAL',
    'CLIENT',
    'GRP_CLIENT',
    'IMMAT',
    'EQUIPE',
  ]
  // const isInitialHeaderSort = TRI_KEYS_TABLE_HEADER?.includes(initial?.tri?.key)
  const [sortConfig, setSortConfig] = useState({
    key: initial?.tri.key ?? null,
    order: initial?.tri?.order ?? 'ASC',
  })

  const [searchStatut, setSearchStatut] = useState<any>(state?.filters?.statut ?? '')
  const [dateDebut, setDateDebut] = useState<string | null>(initial?.dateDebut ?? '')
  const [dateFin, setDateFin] = useState<string | null>(initial?.dateFin ?? '')
  const [isSearch, setIsSearch] = useState(false)
  const [redirectToClientDemande, setRedirectToClientDemande] = useState<boolean>(true)
  const [deleteHover, setDeleteHover] = useState<number | null>(null)
  const [editHover, setEditHover] = useState<number | null>(null)
  const [activateSearch, setActivateSearch] = useState<boolean>(false)
  const [sortField, setSortField] = useState<
    'ASSIGN' | 'DATE' | 'STATUT' | 'CLIENT' | null | string
  >(initial?.tri.key ?? null)
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | string>(
    initial?.tri?.order?.toLowerCase() ?? 'asc'
  )
  const isFirstLoad = useRef(true)
  const [demandeCentre, setDemandeCentre] = useState<string | null>(state?.filters?.centre ?? '')
  const [centres, setCentres] = useState<Array<ModeleEditCentre>>([])
  let userCanTraiterTouteDemande = shouldDisplayFonctionnalite(currentUser, 'TRAITER TOUTE DEMANDE')
  const [tableRefresh, setTableRefresh] = useState<boolean>(false)
  const [defaultValueContact, setDefaultValueContact] = useState<any>('')

  const [isFromAddClientContact, setIsFromAddClientContact] = useState<boolean>(false)
  const [radioValue, setRadioValue] = useState<string>('')
  const [contentCommunication, setContentCommunication] = useState<any>('')
  const [isClientSociety, setIsClientSociety] = useState<boolean>(false)
  const [openActionModal, setOpenActionModal] = useState<boolean>(false)
  const [dataActions, setDataActions] = useState<Array<any>>([])
  const [idDemande, setIdDemande] = useState(state?.idDemande ?? '')
  const [searchTerm, setSearchTerm] = useState<string>('')

  const [panier, setPanier] = useState<Array<any>>([])
  const [demandeId, setDemandeId] = useState<number | null>(null)
  const [pieces, setPieces] = useState<any>([])
  const [dataClientInfos, setDataClientInfos] = useState<any>([])
  const [dataClientInfosTemp, setDataClientInfosTemp] = useState<any>([])
  const [clientDemandeStatus, setClientDemandeStatus] = useState<string>('')
  const [loadingCLientInfo, setLoadingCLientInfo] = useState<boolean>(true)
  const [otherData, setOtherData] = useState<any>([])
  const [isProspect, setIsProspect] = useState<boolean>(false)
  const [panierFiltered, setPanierFiltered] = useState<any>([])
  const [redirectDemandeListPage] = useState<boolean>(true)
  const [demandeClient, setDemandeClient] = useState<ModeleClientDemande | null>(null)
  const [loadingPanier, setLoadingPanier] = useState(false)
  const [demandeSourceValue, setDemandeSourceValue] = useState<any>('')
  const [demandeSources, setDemandeSource] = useState<any | undefined>([])
  const [activeStatut, setActiveStatut] = useState<string | null>(state?.filters?.statut ?? null)
  const [activeSource, setActiveSource] = useState<any>(state?.filters?.source ?? [])
  const [allDemandes, setAllDemandes] = useState<boolean>(state?.filters?.allDemandes ?? true)
  const [totalNouvelle, setTotalNouvelle] = useState<number>(0)
  const [totalAssignee, setTotalAssignee] = useState<number>(0)
  const [totalProposee, setTotallProposee] = useState<number>(0)
  const [totalAcceptee, setTotalAcceptee] = useState<number>(0)
  const [totalRefusee, setTotalRefusee] = useState<number>(0)
  const [totalAccepteeBloquee, setTotalAccepteeBloquee] = useState<number>(0)
  const [totalModifiee, setTotalModifiee] = useState<number>(0)
  const [filterLoading, setFilterLoading] = useState<boolean>(false)
  const abortController = useRef<AbortController | null>(null)
  const abortControllerAdresseDepot = useRef<AbortController | null>(null)
  const [newDemande, setNewDemande] = useState<number>(0)
  const [processedDemande, setProcessedDemande] = useState<number>(0)
  const [oldestAssigned, setOldestAssigned] = useState<any>('')
  const [proposedDemand, setProposedDemand] = useState<number>(0)
  const [acceptedDemand, setAcceptedDemand] = useState<number>(0)
  const [cloturedPositive, setCloturedPositive] = useState<number>(0)
  const [contactedBy, setContactedBy] = useState<any | null>(null)
  const [filters, setFilters] = useState<any>(
    () =>
      initial ?? {
        allDemandes: true,
        statut: [],
        source: [],
        dateDebut: '',
        dateFin: '',
        searchPage: '',
        searchId: '',
        centre: [],
        equipes: [],
        tri: {key: 'ID_DEMANDE', order: 'ASC'},
        shareWithTeam: [],
      }
  )
  const [choicedDemandeSource, setChoicedDemandeSource] = useState<{value: number; label: string}>()
  const [sourceLoader, setSourceLoader] = useState<boolean>(false)
  const refChoiceVehicle = useRef<HTMLButtonElement | null>(null)
  const refRechercheClient = useRef<HTMLButtonElement | null>(null)
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false)
  const [provenances, setProvenances] = useState<any>([])
  const [isAdresseUpdated, setIsAdresseUpdated] = useState<boolean>(false)
  const [updatedFinalAdresseLivInfo, setUpdatedFinalAdresseLivInfo] = useState({
    id: '',
    adresseLiv: '',
    complementAdresseLiv: '',
    telephoneLiv: '',
    cPLiv: '',
    villeLiv: '',
    paysLiv: '',
  })
  const [updatedFinalAdresseFactInfo, setUpdatedFinalAdresseFactInfo] = useState({
    id: '',
    adresseFac: '',
    complementAdresseFac: '',
    telephoneFac: '',
    cPFac: '',
    villeFac: '',
    paysFac: '',
  })
  const requierdFieldLiv = ['adresseLiv', 'telephoneLiv', 'cPLiv', 'villeLiv', 'paysLiv']
  const requierdFieldFac = ['adresseFac', 'telephoneFac', 'cPFac', 'villeFac', 'paysFac']
  const [errorsLiv, setErrorsLIv] = useState({})
  const [errorsFac, setErrorsFac] = useState({})
  const [displayFilter, setDisplayFilter] = useState<boolean>(false)
  const [tempClientId, setTempClientId] = useState<any | null>(null)
  const [tempClient, setTempClient] = useState<any | null>(null)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [isConfirmEdit, setIsConfirmEdit] = useState(false)
  const [contactedByBloc, setContactedByBloc] = useState<string | null>(null)
  const [clientChangeLoader, setClientChangeLoader] = useState<boolean>(false)
  const [piecePropData, setPiecePropData] = useState<any>([])
  const openChoixContactOnClientChange = useRef<HTMLButtonElement>(null)
  const [groupeClientLoader, setGroupeClientLoader] = useState<boolean>(false)
  const [equipes, setEquipes] = useState<Array<ModeleEditEquipe>>([])
  const [demandeEquipe, setDemandeEquipe] = useState<string>(state?.filters?.equipes ?? '')
  const [isPrevious, setIsPrevious] = useState<boolean>(true)
  const [retraitDepot, setRetraitDepot] = useState<boolean>(false)
  const [initialPieces, setInitialPieces] = useState<any[]>([])
  const [checkedPieces, setCheckedPieces] = useState<number[]>([])
  const [totalLibelle, setTotalLibelle] = useState<number>(0)
  const [loadingDepot, setLoadingDepot] = useState<boolean>(false)
  const [adresseDepots, setAdresseDepots] = useState<Array<ModeleAdresseDepot>>([])
  const [commentaireInterne, setCommentaireInterne] = useState<string>('')
  const [demandeVB, setDemandeVB] = useState<any>(null)
  const {selectedPOTAriane, setSelectedPOTAriane, setListePOTAriane, setCommandeAriane} =
    useFilAriane()
  const [totalByFilter, setTotalByFilter] = useState<any>([])
  const [delaisTraitement, setDelaisTraitement] = useState<any>([])

  const [isEditPanier, setIsEditPanier] = useState<boolean>(false)

  // Adresse de facturation / livraison > Création / Modification depuis Fiche client
  const [livraisonSelectedValue, setLivraisonSelectedValue] = useState({value: '', label: ''})
  const [facturationSelectedValue, setFacturationSelectedValue] = useState({value: '', label: ''})
  const [itemPerPage, setItemPerPage] = useState<25 | 50 | 100>(state?.filters?.itemPerPage ?? 25)
  const [openFilter, setOpenFilter] = useState<boolean>(false)
  const navigate = useNavigate()
  // const filtersRef = useRef(filters)
  const [baseline, setBaseline] = useState(filters)
  const [manualFilters, setManualFilters] = useState<any>({
    allDemandes: true,
    statut: [],
    source: [],
    dateDebut: '',
    dateFin: '',
    searchPage: '',
    searchId: '',
    centre: [],
    equipes: [],
    tri: {key: 'ID_DEMANDE', order: 'ASC'},
    shareWithTeam: [],
  })
  const [favoris, setFavoris] = useState<any>([])
  const [lastFilters, setLastFilters] = useState({
    allDemandes: true,
    statut: [],
    source: [],
    dateDebut: '',
    dateFin: '',
    searchPage: '',
    searchId: '',
    centre: [],
    equipes: [],
    tri: {key: 'ID_DEMANDE', order: 'ASC'},
    shareWithTeam: [],
  })

  useEffect(
    function saveTempFilterOnTableHeaderSort() {
      if (TRI_KEYS_TABLE_HEADER?.includes(filters?.tri?.key)) {
        saveFilters({
          ...filters,
          tri: {
            key: filters?.tri?.key,
            order: filters?.tri?.order,
          },
        })
      }
    },
    [sortField, sortOrder]
  )

  interface LocationState {
    showCancelToast: boolean
    showSubmitToast: boolean
    showEditToast: boolean
    idDemande: number | null | undefined | string
    showSendedEmailToast: boolean
    showValidationToast: boolean
    idToastMailSend: any
    idToastValidate: any
    showAnnulationToast: boolean
    filters?: any
    clientIdDuplicate?: number | string | undefined
    contactId?: any
    clientToDuplicate?: any
    choicedDemandeSource?: any
  }

  // Pour renseigner les champs dans le modal choix de contact lors de la duplication
  useEffect(() => {
    setClientId(state?.clientToDuplicate?.clientId ?? '')
    if (state?.clientToDuplicate?.choicedDemandeSource)
      setChoicedDemandeSource(state?.clientToDuplicate?.choicedDemandeSource)
    if (state?.clientToDuplicate?.defaultValueContact)
      setDefaultValueContact(state?.clientToDuplicate?.defaultValueContact)
    if (state?.clientToDuplicate?.radioValue) setRadioValue(state?.clientToDuplicate?.radioValue)
    if (state?.clientToDuplicate?.contentCommunication)
      setContentCommunication(state?.clientToDuplicate?.contentCommunication)
    setIsDuplicate(state?.clientToDuplicate?.isDuplication)
    if (state?.clientToDuplicate?.searchTerm) setSearchTerm(state?.clientToDuplicate?.searchTerm)
    setTimeout(() => {
      if (refChoiceVehicle?.current && state?.clientToDuplicate?.clientId) {
        refChoiceVehicle.current.click()
      }
    }, 500)
  }, [state?.clientToDuplicate])

  const formik = useFormik({
    initialValues: {
      allSearch: state?.filters?.searchPage ?? '',
      statut: state?.filters?.statut ?? '',
      demandeCentre: state?.filters?.centre ?? '',
      source: state?.filters?.source ?? '',
      searchId: state?.filters?.source ?? '',
      demandeEquipe: state?.filters?.equipes ?? '',
    },
    onSubmit: (values, {setSubmitting}) => {
      setIsSearch(true)
      setSearchStatut(values.statut)
      setDemandeEquipe(values.demandeEquipe)
    },
  })

  const handleSelectDemande = (id: number) => {
    setIdDemande(id)
  }

  // Pour récupérer le label d'un centre afin de l'afficher par défaut
  function getCentreFiltered(value) {
    return centres.find((opt) => opt.value === value)
  }

  //  Pour récupérer le label des équipes afin de l'afficher par défaut
  function getEquipeFiltered(value) {
    if (!value) return []
    return equipes.filter((eqp) => value.split(',').map(Number).includes(eqp.value))
  }

  const getListDelaisTraitement = () => {
    getAllDelaisTraitement()
      .then((response) => {
        if (response?.status === 200 && response?.data !== undefined) {
          setDelaisTraitement(response?.data?.filter((item) => item?.actif === true))
        }
      })
      .catch(() => console.error('erreur'))
  }

  // Récupération des données de demande en fonction de id client ou non
  const getClientDemandeData = async (overrideFilters) => {
    // fusionne l'override avec filter, override gagne si défini
    const activeFilters = {
      ...(filtersRef.current ?? {}),
      ...(overrideFilters ?? {}),
    }
    setLastFilters(activeFilters)

    if (abortController.current) {
      abortController.current.abort()
    }
    const controller = new AbortController()
    abortController.current = controller

    setTableRefresh(true)
    SelectedClient != null ? setRedirectToClientDemande(true) : setRedirectToClientDemande(false)

    //les centres de l'utilisateur connectés
    const userConnectedCentres = currentUser?.listeCentres ?? []
    let userConnectedCentresString: any = []
    if (userConnectedCentres.length) {
      userConnectedCentresString = userConnectedCentres
        .flat()
        .map((c) => c.id)
        .join(',')
    }

    //les équipes de l'utilisateur connectés
    const userConnectedEquipes = currentUser?.utilisateurEquipes ?? []
    if (userConnectedEquipes.length) {
      const transformedData = userConnectedEquipes.map((item) => ({
        value: item?.equipe?.id,
        label: item?.equipe?.nom,
      }))
      setEquipes([...transformedData])
    } else {
      getEquipeUtilisateurData()
    }

    try {
      const clientDemandesRequest = await getDemandes(
        currentPage,
        activeFilters['searchPage'],
        activeFilters['statut'],
        activeFilters['statusMode'],
        activeFilters['source'],
        sessionStorage.getItem('idClient') ?? SelectedClient, // si session idClient depuis btn historique client , on passe l'idClient
        activeFilters['dateDebut'],
        activeFilters['dateFin'],
        activeFilters['equipes'],
        idDemande ? '' : userConnectedCentresString,
        idDemande,
        activeFilters['allDemandes'],
        activeFilters['searchId'],
        activeFilters['tri'],
        activeFilters['itemPerPage'],
        controller.signal
      )
      if (clientDemandesRequest?.status === 200 && clientDemandesRequest?.data) {
        const {pages, total, data, stats} = clientDemandesRequest.data
        setNombreDePages(pages)
        setTotalPages(total)
        setData(data)
        setIdDemande('')

        // setTotalNouvelle(stats?.totalNouvelle)
        // setTotalAcceptee(stats?.totalAcceptee)
        // setTotalAssignee(stats?.totalAssignee)
        // setTotalAccepteeBloquee(stats?.totalAccepteeBloquee)
        // setTotalRefusee(stats?.totalRefusee)
        // setTotallProposee(stats?.totalProposee)
        // setTotalModifiee(stats?.totalModifiee)
        setTotalByFilter(stats?.totalByFilter)
      }
    } catch (error: unknown) {
      console.error('Error fetching client demandes:', error)
      if (axios.isAxiosError(error) && error.code === 'ERR_CANCELED') {
        console.warn('Request annulée')
        return
      }
      console.error('Erreur fetching client demandes:', error)
    } finally {
      setLoading(false)
      setIsSearch(false)
      if (abortController.current === controller) {
        setTableRefresh(false)
      }
    }
  }

  useEffect(
    function statInfoSetter() {
      const getTotal = (etapeLibelle: string) =>
        totalByFilter?.find((item) => item.code === etapeLibelle)?.total ?? 0

      const totalProcessed = getTotal('ACCEP') + getTotal('REFUS') + getTotal('BLOQU')
      setNewDemande(getTotal('NOUVE'))
      setProcessedDemande(totalProcessed)
      setProposedDemand(getTotal('PROPO'))
      setAcceptedDemand(getTotal('ACCEP'))
      setCloturedPositive(getTotal('CLOTP'))
    },
    [totalByFilter]
  )

  // Pour récupérer les données si il y a un ou des filtres stocker lors de la navigation
  // Date, recherche globale, centre
  // useEffect(() => {
  //   if (
  //     state?.filters?.dateDebut ||
  //     state?.filters?.dateFin ||
  //     state?.filters?.searchPage ||
  //     state?.filters?.centre ||
  //     state?.filters?.searchId ||
  //     state?.filters?.equipes
  //   ) {
  //     getClientDemandeData(null)
  //   }
  // }, [state])

  useEffect(() => {
    if (!data || data.length === 0) return
    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)

    const endOfToday = new Date()
    endOfToday.setHours(23, 59, 59, 999)

    const normalizedData = data.map((obj) => obj[0])

    const todayData = normalizedData.filter((item) => {
      if (!item?.dateAssignation) return false
      const dateAssign = new Date(item?.dateAssignation)
      return (
        dateAssign >= startOfToday &&
        dateAssign <= endOfToday &&
        item.clientDemandeEtape?.code === 'ASSIG'
      )
    })

    if (todayData.length === 0) {
      setOldestAssigned(null)
      return
    }

    const oldestItemToday = todayData.reduce((oldest, current) => {
      return new Date(current?.dateAssignation ?? '') < new Date(oldest?.dateAssignation ?? '')
        ? current
        : oldest
    })

    setOldestAssigned(oldestItemToday)
  }, [data])

  const getMesActionsData = () => {
    return getMesActions(currentUser?.id)
      .then((mesActionsRequest) => {
        if (mesActionsRequest?.status === 200) {
          if (mesActionsRequest?.data !== undefined) {
            setDataActions(mesActionsRequest?.data)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  // Données formatées pour le filtre des centres
  const getCentresData = () => {
    getCentreAll()
      .then((centresRequest) => {
        const transformedData = centresRequest.map((item) => ({
          value: item.id,
          label: item.nom,
        }))
        setCentres([...transformedData])
      })
      .catch((e) => {})
  }

  // Données formatées pour le filtre des équipes
  const getEquipeUtilisateurData = () => {
    getEquipeUtilisateur()
      .then((request) => {
        if (request?.data !== undefined && request?.status === 200) {
          const transformedData = request.data.map((item) => ({
            value: item.id,
            label: item.nom,
          }))
          setEquipes([...transformedData])
        }
      })
      .catch((e) => {
        console.error('erreur: ', e)
      })
  }

  useEffect(() => {
    if (!isSearch && !isFirstLoad.current) {
      setCurrentPage(1)
    }
  }, [isSearch])

  useEffect(() => {
    // Desactivé la recherche si les deux dates sont vides et l'activé si l'une d'elle a une valeur
    if (
      dateDebut === '' &&
      dateFin === '' &&
      searchPage === '' &&
      demandeCentre === '' &&
      searchId === '' &&
      demandeEquipe === ''
    ) {
      setActivateSearch(false)
      setIsSearch(false)
      if (currentPage !== 1) {
        setCurrentPage(1)
      }
      // else {
      //   getClientDemandeData(null)
      // }
    } else if (searchPage.length > 0 || searchId !== '') {
      getClientDemandeData(null)

      setActivateSearch(true)
    } else if (dateDebut !== '' || dateFin !== '' || demandeCentre !== '' || demandeEquipe !== '') {
      setActivateSearch(true)
      // Affiché une toast si dateFin est inférieur à dateDebut ou si dateFin n'a pas de valeur
      if (dateDebut !== null && dateFin !== null && dateFin < dateDebut) {
        if (dateFin !== '') {
          toast.warning('Veuillez saisir une date de début antérieure à la date de fin.')
          setActivateSearch(false)
        }
      }
    } else {
      setActivateSearch(false)
    }
  }, [dateDebut, dateFin, searchPage, demandeCentre, searchId, demandeEquipe])

  const dataRef = useRef(data)
  useEffect(() => {
    dataRef.current = data
  }, [data])

  const filtersRef = useRef(filters)
  useEffect(() => {
    filtersRef.current = filters
  }, [filters])

  const getClientDemandeDataRef = useRef(getClientDemandeData)
  useEffect(() => {
    getClientDemandeDataRef.current = getClientDemandeData
  }, [getClientDemandeData])

  useEffect(() => {
    if (openFilter) return // Ignorer lors de l'ouverture des favoris
    // Configure l'intervalle de 60 secondes (60000 ms)
    const intervalId = setInterval(() => {
      if (dataRef.current.length > 1) {
        getClientDemandeDataRef.current(filtersRef.current)
      }
      // getMesActionsData()
      setTrigger((prev) => prev + 1)
    }, 60000)

    // Nettoie l'intervalle lorsque le composant est démonté
    return () => clearInterval(intervalId)
  }, [openFilter])

  useEffect(() => {
    getClientDemandeData(null)
  }, [itemPerPage])

  useEffect(() => {
    const container = document.getElementById('kt_content_container')
    const content = document.getElementById('kt_content')
    const footer = document.getElementById('kt_footer')

    const previousContainerClass = container?.className ?? ''
    const previousContainerStyle = container?.style.cssText ?? ''

    const previousContentClass = content?.className ?? ''
    const previousContentStyle = content?.style.cssText ?? ''

    const previousFooterStyle = footer?.className ?? ''

    if (container) {
      container.classList.remove('container-xxl')
      container.classList.add('container-fluid')
      container.classList.add('d-flex', 'flex-column')

      container.style.flex = '1 1 auto'
      container.style.minHeight = '0'
      container.style.overflow = 'hidden'
    }

    if (content) {
      content.classList.add('d-flex', 'flex-column')

      content.style.flex = '1 1 auto'
      content.style.minHeight = '0'
      content.style.overflow = 'hidden'
      content.style.padding = '10px 0'
    }

    if (footer) {
      footer.classList.add('d-none')
    }

    return () => {
      if (container) {
        container.className = previousContainerClass
        container.style.cssText = previousContainerStyle
      }

      if (content) {
        content.className = previousContentClass
        content.style.cssText = previousContentStyle
      }

      if (footer) {
        footer.className = previousFooterStyle
      }
    }
  }, [])

  // Récupération des status des demandes
  const getCLientDemandeEtapeData = () => {
    return getClientDemandeEtape()
      .then((demandeEtapeRequest) => {
        if (demandeEtapeRequest?.status === 200) {
          if (demandeEtapeRequest?.data !== undefined) {
            const transformedData = demandeEtapeRequest.data.map((item) => ({
              value: item.code,
              label: item.libelle,
            }))
            setclientDemandeEtape([...transformedData])
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const getClientDemandeSourceData = () => {
    setSourceLoader(true)
    return getDemandeSource().then((demandeSourceRequest) => {
      if (demandeSourceRequest?.status === 200) {
        if (demandeSourceRequest?.data !== undefined) {
          setSourceLoader(false)
          setDemandeSource(demandeSourceRequest?.data)
        }
      }
    })
  }

  // Transformation source demande en objet value label pour ne pas gâcher le donnée originel
  const transformedSource = demandeSources?.map((item) => ({
    value: item.id,
    label: item.name,
  }))

  const getDemandeStatInfo = () => {
    let centreId =
      currentUser && currentUser?.role?.code !== 'ADMIN'
        ? currentUser?.listeCentres?.[0]?.map((centre) => centre.id)?.join(',') ?? null
        : null
    // si session idClient depuis btn historique client , on passe l'idClient au lieu de SelectedClient
    return getCountByState(
      allDemandes,
      sessionStorage.getItem('idClient') ?? SelectedClient,
      centreId,
      demandeEquipe
    ).then((res) => {
      if (res?.status === 200 && res?.data !== undefined) {
        //Setter infoCard
        setNewDemande(res?.data.totalnewDemande)
        setProcessedDemande(res?.data.totalprocessedDemande)
        setProposedDemand(res?.data.proposedDemand)
        setAcceptedDemand(res?.data.acceptedDemand)
        setCloturedPositive(res?.data.todayCloturedPositiveDemand)
      }
    })
  }

  useEffect(() => {
    // Ajout de spinner pour charger toutes les données de filtre avant de les affichées
    const fetchAll = async () => {
      try {
        setFilterLoading(true)

        await Promise.all([
          getCLientDemandeEtapeData(),
          // getMesActionsData(),
          getClientDemandeSourceData(),
          // getDemandeStatInfo(),
          getAllProvenancePiece(),
          getListDelaisTraitement(),
        ])
      } finally {
        setFilterLoading(false)
      }
    }
    fetchAll()

    return () => {
      // on demonte le contenu du session "idClient" quand on change de page
      sessionStorage.removeItem('idClient')
    }
  }, [])

  // Style du select pour le filtre des centres
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
    }),
  }

  //Suppresion d'une demande
  const handleDemandeDelete = (id: number) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
      heightAuto: false,
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToast = toast.loading('Suppression en cours...')
        deleteDemande(id)
          .then((response) => {
            if (response?.status === 204) {
              setData((prev) => prev.filter((p) => p?.[0]?.id !== id))
              getClientDemandeData(null)
              setLoading(false)
              toast.update(idToast, {
                render: 'Demande supprimée avec succès.',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            }
          })
          .catch((error) => {
            //si code 500 ou autre que 204
            getClientDemandeData(null)
            setLoading(false)
            toast.update(idToast, {
              render: 'Erreur lors de la suppression.',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
          })
      }
    })
  }

  useEffect(
    function refetchDemandeFromTableHeaderSorting() {
      if (
        (filters?.tri?.key === 'ASSIGN' ||
          filters?.tri?.key === 'DATE' ||
          filters?.tri?.key === 'DELAI' ||
          filters?.tri?.key === 'STATUT' ||
          filters?.tri?.key === 'CANAL' ||
          filters?.tri?.key === 'GRP_CLIENT' ||
          filters?.tri?.key === 'IMMAT' ||
          filters?.tri?.key === 'EQUIPE' ||
          filters?.tri?.key === 'CLIENT') &&
        !openFilter
      ) {
        handleSortData()
      }
    },
    [filters?.tri?.order, filters?.tri?.key]
  )

  const sortedData = [...data].sort((a, b) => {
    if (!sortField) return 0 // pas de tri si aucun tri demandé

    return 0
  })

  useEffect(() => {
    const displayAllDemandes = shouldDisplayFonctionnalite(currentUser, 'VOIR TOUTE DEMANDE')
    if (!displayAllDemandes) {
      setAllDemandes(false)
    }
    if (isFirstLoad.current) {
      isFirstLoad.current = false
      return
    }
    const timer = setTimeout(() => {
      getClientDemandeData(null)
      // getDemandeStatInfo()
    }, 100)

    return () => clearTimeout(timer)
  }, [currentPage, searchStatut, activeSource, allDemandes])

  // useEffect(() => {
  //   if (idDemande) {
  //     getClientDemandeData(null)
  //   }
  // }, [idDemande])

  const showActionModal = () => {
    setOpenActionModal(true)
  }

  const toggleShowActionModal = (val: boolean) => {
    setOpenActionModal(val)
  }

  // Utilisation de getClient pour avoir les données du client
  // avec son groupe et son taux de remise
  useEffect(() => {
    if (dataClientInfosTemp.id) {
      setGroupeClientLoader(true)
      getClient(dataClientInfosTemp.id)
        .then((res) => {
          if (res?.status === 200 && res?.data?.id) {
            const updatedData = {...res.data}
            updatedData.idPays = updatedData.pays?.id
            setDataClientInfos(updatedData)
          }
          setGroupeClientLoader(false)
        })
        .catch(() => console.error('erreur'))
    }
  }, [dataClientInfosTemp])

  const getDemandeProposition = async () => {
    setLoadingPanier(true)

    try {
      const clientDemandeImmat = await getClientDemandeImmat(demandeClient?.id)
      if (clientDemandeImmat?.status === 200 && clientDemandeImmat?.data !== undefined) {
        setCommentaireInterne(clientDemandeImmat.data?.demande?.commentaire ?? '')
      }
      const clientDemandeProp = await getDemandeProposee(demandeClient?.id)
      if (clientDemandeProp?.status === 200 && clientDemandeProp?.data.length > 0) {
        const newPanier = clientDemandeProp?.data
        const finalPanier = newPanier?.map((piece) => {
          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : dataClientInfos && dataClientInfos?.professionnel === false
            ? 10
            : 20

          const pieceExclue = !!dataClientInfos?.sauf?.some(
            (item) => item.label === piece.nomTypePieceProposee
          )
          const fraisOffert = !!dataClientInfos?.fraisPortOffert && !pieceExclue
          const fraisDePort =
            fraisOffert || demandeClient?.retraitDepot ? 0 : Number(piece?.fraisDePort)

          const taux = Number(piece?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt = Number(piece?.prixReferentiel) ?? 0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
          }
        })
        setPanier(finalPanier)
        setPanierFiltered(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
              }
            })
          setInitialPieces(copieInitiale)
        }
      }
    } catch (error) {
      console.error('Error get client demande proposee:', error)
    } finally {
      setLoadingPanier(false)
    }
  }

  const showModal = (id) => {
    const el = document.getElementById(id)
    if (el) {
      Modal.getOrCreateInstance(el).show()
    }
  }

  const handlePanier = async (demande) => {
    setClientId(demande?.client?.id)
    setDemandeId(demande?.id)
    setDemandeClient(demande)
    if (demande?.retraitDepot !== undefined) {
      setRetraitDepot(demande?.retraitDepot)
    }
    setDemandeSourceValue(demande?.demandeSource)

    // Modal du client
    if (demande?.changeClient) {
      setIsEdit(true)
      showModal('exampleModalToggle')
    } else {
      // Modal du panier
      showModal('kt_modal_1')
    }

    setLoadingPanier(true)
    const clientDemandePieces = demande?.pieces
    const clientDemandeEtapes = demande?.clientDemandeEtape
    const updatedPieces = clientDemandePieces.map((piece) => ({
      ...piece,
      demande: {
        clientDemandeEtape: clientDemandeEtapes,
        client: demande?.client,
        id: demande?.id,
      },
    }))

    setPieces(updatedPieces)
    setDataClientInfos(demande?.client)
    setDataClientInfosTemp(demande?.client)
    setClientDemandeStatus(demande.clientDemandeEtape.code)
    setOtherData(demande?.contactedBy)
    setContactedBy(demande?.contactedBy)

    if (demande?.client) {
      setLoadingCLientInfo(false)
      if (demande?.client?.typeClient === 'PROSPECT') {
        setIsProspect(true)
      }
    }
    try {
      const clientDemandeImmat = await getClientDemandeImmat(demande?.id)
      if (clientDemandeImmat?.status === 200 && clientDemandeImmat?.data !== undefined) {
        setCommentaireInterne(clientDemandeImmat.data?.demande?.commentaire ?? '')
      }
      const clientDemandeProp = await getDemandeProposee(demande?.id)
      if (clientDemandeProp?.status === 200 && clientDemandeProp?.data.length > 0) {
        const newPanier = clientDemandeProp?.data
        const finalPanier = newPanier?.map((piece) => {
          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : dataClientInfos && dataClientInfos?.professionnel === false
            ? 10
            : 20

          const pieceExclue = !!dataClientInfos?.sauf?.some(
            (item) => item.label === piece.nomTypePieceProposee
          )
          const fraisOffert = !!dataClientInfos?.fraisPortOffert && !pieceExclue
          const fraisDePort = fraisOffert || demande?.retraitDepot ? 0 : Number(piece?.fraisDePort)

          const taux = Number(piece?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt = Number(piece?.prixReferentiel) ?? 0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
          }
        })
        setPanier(finalPanier)
        setPanierFiltered(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
              }
            })
          setInitialPieces(copieInitiale)
        }
      }
    } catch (error) {
      console.error('Error get client demande proposee:', error)
    } finally {
      setLoadingPanier(false)
    }
  }

  const handleDismiss = () => {
    setPanierFiltered(panier)
  }

  const handlePanierFiltered = (newPanier) => {
    setPanierFiltered(newPanier)
  }

  const statutColors: Record<string, string> = {
    NOUVE: 'info',
    ASSIG: 'dark',
    PROPO: 'warning',
    ACCEP: 'success',
    REFUS: 'danger',
    CANCE: 'bg-light',
    BLOQU: 'warning',
    MODIF: 'warning',
  }

  const statutCount: Record<string, number> = {
    NOUVE: totalNouvelle,
    ASSIG: totalAssignee,
    PROPO: totalProposee,
    ACCEP: totalAcceptee,
    REFUS: totalRefusee,
    BLOQU: totalAccepteeBloquee,
    MODIF: totalModifiee,
  }

  const ActionLink = ({tag, clientDemande, isBtn = false}) => (
    <Link
      to={`/demandes/${clientDemande[0]?.client?.id}/traitement/${clientDemande[0]?.id}`}
      className={isBtn ? 'btn btn-icon btn-bg-light btn-active-color-primary btn-sm' : ''}
      state={{
        redirectToClientDemande: redirectToClientDemande,
        isFromClient: isFromClient,
        autoAssign:
          clientDemande?.[0]?.utilisateurAssigne === null &&
          (clientDemande?.[0]?.clientDemandeEtape.code === 'NOUVE' ||
            clientDemande?.[0]?.clientDemandeEtape.code === 'MODIF'),
        filters: filters,
        provenances: provenances,
        clientDemandeStatus: clientDemande?.[0]?.clientDemandeEtape?.code ?? '',
        demandeClient: demandeClient ?? clientDemande?.[0],
        idFormattedArr: data.map((item) => ({
          demande: item?.[0],
          demandeId: item?.[0]?.id,
          clientId: item?.[0]?.client?.id,
        })),
        pagination: {totalPages: totalPages, currentPage: currentPage, pageSize: itemPerPage},
        loadedFromPage: currentPage,
        loadedToPage: currentPage,
        activeFilters: lastFilters,
      }}
      data-tooltip-id='demande-action-tooltip'
      data-tooltip-content={
        clientDemande?.[0]?.clientDemandeEtape?.code === 'BLOQU'
          ? `Bloquée : ${clientDemande.hasVirement ? '-Virement' : ''}${
              clientDemande.hasPOT ? '-POT' : ''
            }${!clientDemande.hasVirement && !clientDemande.hasPOT ? '-Prospect' : ''}`
          : 'Traiter la demande'
      }
      data-tooltip-place='left'
    >
      {tag}
    </Link>
  )

  // Pour mettre à jour les filtres afin de les garder lors de la navigation
  const updateFilter = (key, value) => {
    setCurrentPage(1)
    const newValue = typeof value === 'function' ? value(filters[key]) : value

    setFilters((prev) => {
      const next = typeof value === 'function' ? value(prev[key]) : value
      return isEqual(next, prev[key]) ? prev : {...prev, [key]: next}
    })

    setManualFilters((prev) => ({
      ...prev,
      [key]: typeof value === 'function' ? value(prev[key]) : value,
    }))

    // Effets de bord hors des setState
    if (key === 'tri' && TRI_KEYS_TABLE_HEADER.includes(newValue?.key) && !openFilter) {
      setFavoris((prev) => prev?.map((fav) => ({...fav, actif: false})))
      setSortField(newValue?.key)
      setSortOrder(newValue?.order)
      setSortConfig({key: null, order: 'ASC'})
    }
  }

  // Pour la duplication de demande pour le même client
  const handleDuplicate = (demande) => {
    // Pour dupliquer email - sms - appel
    const dem = demande[0]
    const radioV = dem?.email ? 'email' : dem?.sms ? 'sms' : 'appel'
    const content = dem?.communication
    setClientId(demande?.[0]?.client?.id)
    setDefaultValueContact(demande?.[0]?.contactedBy?.id)
    setRadioValue(radioV)
    setContentCommunication(content ?? '')
    setIsDuplicate(true)
    setChoicedDemandeSource(demande?.[0]?.demandeSource?.id)
    if (refChoiceVehicle?.current) refChoiceVehicle.current.click()
  }

  // Setter la valeur de duplicate en false
  const toggleDuplicate = () => {
    setIsDuplicate(false)
  }

  // Récupération provenance de pièce
  const getAllProvenancePiece = () => {
    getProvenancePiece().then((res) => {
      // setIsLoadingProvenance(true)
      if (res.status === 200 && res.data) {
        const transformedData = res.data.map((item) => ({
          value: item.id,
          label: item.libelle,
        }))
        setProvenances([...transformedData])
        // setIsLoadingProvenance(false)
      } else {
        console.error('Erreur lors de la récupération des données')
        // setIsLoadingProvenance(false)
      }
    })
  }

  useEffect(
    function setTempClientIdToClientId() {
      if (tempClientId != null) setClientId(tempClientId)
    },
    [tempClientId]
  )

  const showToastPOT = () => {
    toast.success(`Pièce d'occasion taxable modifiée avec succès.`, {
      hideProgressBar: true,
      autoClose: 2000,
    })
  }

  const handleUpdateClientData = (onSuccess) => {
    setClientChangeLoader(true)
    // setIsConfirmEdit(true)
    setClientId(tempClientId)
    changeClientOnDemande(
      tempClientId,
      demandeId,
      radioValue,
      contactedBy,
      contentCommunication,
      panier.map((p) => p.idPiecePropose)
    ).then((res) => {
      if (res?.status !== 200) {
        console.error('Erreur lors de la changement de client')
        setClientChangeLoader(false)
      } else {
        setOtherData({contactedBy})
        setDataClientInfos(tempClient)
        setDataClientInfosTemp(tempClient)

        const demande = res?.data?.demande
        const client = res?.data?.client

        // Mise à jour de la liste des demandes en live après modification d'un client
        const updatedData = data?.map((item) => {
          if (item?.[0]?.id === demandeId) {
            const updatedData = {
              ...item?.[0],
              changeClient: res?.data?.demande?.changeClient,
              equipe: res?.data?.demande?.equipe,
              equipeInitial: res?.data?.demande?.equipeInitial
            }
            return {
              ...item,
              0: updatedData
            }
          } else {
            return item
          }
        })
        setData(updatedData)

        setRetraitDepot(demande?.retraitDepot)

        // Mise à jour du panier avec le taux de remise du nouveau client
        const finalPanier = panier?.map((piece) => {
          const responsePanier = res?.data?.panier
          const pieceResponsePanier = responsePanier?.find(
            (panier) => panier?.id === piece?.idPiecePropose
          )

          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : client && client?.professionnel === false
            ? 10
            : 20
          const fraisDePort = demande?.retraitDepot
            ? 0
            : Number(pieceResponsePanier?.prixTransport) ?? 0
          const fraisDePortInitial = Number(pieceResponsePanier?.prixTransport ?? 0)

          const taux = Number(pieceResponsePanier?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece?.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt = Number(pieceResponsePanier?.prixReferentiel) ?? 0

          const prixVenteProposeeHt = Number(prixReferentielHt - prixReferentielHt * (taux / 100))
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            fraisDePortInitial: Number(fraisDePortInitial?.toFixed(2)),
          }
        })
        setPanier(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
              }
            })
          setInitialPieces(copieInitiale)
        }

        if (demandeClient) {
          setDemandeClient({
            ...demandeClient,
            client: res.data?.demande?.client,
            appel: radioValue === 'appel',
            sms: radioValue === 'sms',
            email: radioValue === 'email',
            communication: contentCommunication,
          })
        }

        // Mise à jour de la liste après la modification de client
        setData((prevList) =>
          prevList.map((item) => {
            if (item['0'] && item['0'].id === res.data?.demande?.id) {
              return {
                ...item,
                '0': {
                  ...item['0'],
                  client: res.data?.demande?.client,
                },
              }
            }
            return item
          })
        )
        setPiecePropData(res?.data?.panier)
        openChoixContactOnClientChange?.current?.click()
        setClientChangeLoader(false)
      }
    })
  }

  const handleChangeEquipes = (data) => {
    const equipeFilter = data
      ? data
          .map((equipe) => equipe.value)
          .filter((value, index, self) => self.indexOf(value) === index)
          .join(',')
      : ''
    formik.setFieldValue('demandeEquipe', equipeFilter)
    setDemandeEquipe(equipeFilter)
    updateFilter('equipes', equipeFilter)
  }

  // Pour rafraichir les données de ta table lors d'un tri par date | user assigné | client | statut
  const handleSortData = () => {
    getClientDemandeData(null)
  }

  const getAdresseRetraitDepot = async (source: string) => {
    setLoadingDepot(true)

    if (abortControllerAdresseDepot.current) {
      abortControllerAdresseDepot.current.abort()
    }
    const controller = new AbortController()
    abortControllerAdresseDepot.current = controller

    try {
      const res = await getAdresseDepotBySourceDemande(source, controller.signal)
      if (res.data) setAdresseDepots(res.data)
    } catch (e) {
      if (axios.isAxiosError(e) && e.code === 'ERR_CANCELED') {
        return
      }
      console.error(e)
    } finally {
      if (abortControllerAdresseDepot.current === controller) {
        setLoadingDepot(false)
      }
    }
  }

  const handleModalVB = (dem) => {
    setDemandeVB(dem)
  }

  const handleList = (stat: string, demande: ModeleClientDemande) => {
    setTotalAccepteeBloquee((prevAb) => prevAb - 1)
    setData((prevData) =>
      prevData.map((item) => (item[0].id === demande.id ? {...item, '0': demande} : item))
    )
    if (stat === 'ACCEP' && demande?.clientDemandeEtape?.code === 'ACCEP') {
      setTotalAcceptee((prevAc) => prevAc + 1)
    } else if (demande?.clientDemandeEtape?.code === 'REFUS') {
      setTotalRefusee((prevRf) => prevRf + 1)
    }
  }

  const openDemandeTraitement = (demande, e) => {
    navigate(`/demandes/${demande?.client?.id}/traitement/${demande?.id}`, {
      state: {
        redirectToClientDemande,
        isFromClient,
        autoAssign:
          demande?.utilisateurAssigne === null &&
          (demande?.clientDemandeEtape.code === 'NOUVE' ||
            demande?.clientDemandeEtape.code === 'MODIF'),
        filters,
        provenances,
        clientDemandeStatus: demande?.clientDemandeEtape?.code ?? '',
        demandeClient: demandeClient ?? demande,
        idFormattedArr: data.map((item) => ({
          demande: item?.[0],
          demandeId: item?.[0]?.id,
          clientId: item?.[0]?.client?.id,
        })),
        pagination: {totalPages: totalPages, currentPage: currentPage, pageSize: itemPerPage},
        loadedFromPage: currentPage,
        loadedToPage: currentPage,
        activeFilters: lastFilters,
      },
    })
  }

  const renderTempsEcoule = (demandeClient) => {
    const estAvantTraitement = !demandeClient?.dateProposition
    const estTraitee = !!demandeClient?.delaiTraitementReel
    return (
      <TempsEcoule
        date={
          !estTraitee
            ? estAvantTraitement
              ? demandeClient?.dateCreation
              : demandeClient?.delaiIntermediaire ?? demandeClient?.dateProposition
            : demandeClient?.dateCreation
        }
        dateMax={
          estAvantTraitement ? demandeClient?.delaiAvantTraitement : demandeClient?.delaiTraitement
        }
        dateReel={
          !estTraitee
            ? estAvantTraitement
              ? demandeClient?.delaiAvantTraitementReel
              : demandeClient?.delaiTraitementReel
            : demandeClient?.delaiTraitementReel
        }
        heureOuverture={extractedHour(demandeClient?.equipe?.heureDebut)}
        heureFermeture={extractedHour(demandeClient?.equipe?.heureFin)}
        heurePauseDebut={extractedHour(demandeClient?.equipe?.heureDebutPause)}
        heurePauseFin={extractedHour(demandeClient?.equipe?.heureFinPause)}
        joursSpecifiques={demandeClient?.equipe?.specificDay}
        affichageBadge={true}
      />
    )
  }

  return (
    <>
      <div
        className='card gap-2 p-2 d-flex flex-column'
        style={{
          background: isFromModalClient ? '#80808014' : undefined,
          flex: '1 1 0',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {!isFromModalClient && (
          <>
            <div className='d-flex gap-6'>
              <DemandeSearchFilter
                currentUser={currentUser}
                isPro={isPro}
                SelectedClient={SelectedClient}
                setClientId={setClientId}
                setIsEdit={setIsEdit}
                setDemandeId={setDemandeId}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setIsClientSociety={setIsClientSociety}
                searchId={searchId}
                setSearchId={setSearchId}
                searchPage={searchPage}
                setSearchPage={setSearchPage}
                getClientDemandeData={getClientDemandeData}
                clientDemandeEtape={clientDemandeEtape}
                clientDemandeCanal={transformedSource}
                dateDebut={dateDebut}
                setDateDebut={setDateDebut}
                dateFin={dateFin}
                setDateFin={setDateFin}
                formik={formik}
                clientDemandeEquipe={equipes}
                filters={filters}
                setFilters={setFilters}
                updateFilter={updateFilter}
                tableRefresh={tableRefresh}
                setTableRefresh={setTableRefresh}
                baseline={baseline}
                setBaseline={setBaseline}
                manualFilters={manualFilters}
                setManualFilters={setManualFilters}
                loadFilters={loadFilters}
                sortConfig={sortConfig}
                setSortConfig={setSortConfig}
                initial={initial}
                favoris={favoris}
                setFavoris={setFavoris}
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
                TRI_KEYS_TABLE_HEADER={TRI_KEYS_TABLE_HEADER}
                setSortField={setSortField}
                setSortOrder={setSortOrder}
              />

              <InfoCard
                dataActions={dataActions}
                showActionModal={showActionModal}
                newDemande={newDemande}
                processedDemande={processedDemande}
                oldestAssignedDemand={oldestAssigned?.dateAssignation}
                oldestDelaiTraitement={oldestAssigned?.delaiTraitement}
                proposedDemand={proposedDemand}
                acceptedDemand={acceptedDemand}
                cloturedPositive={cloturedPositive}
                filters={filters}
              />
            </div>

            {/*Modal that display Client researchBar*/}
            <ResearchClientModal
              setClientId={setClientId}
              clientId={clientId}
              setIsClientSociety={setIsClientSociety}
              setIsCreateViaModal={setIsCreateViaModal}
              defaultValueContact={defaultValueContact}
              sourceLoader={sourceLoader}
              choicedDemandeSource={isEdit ? demandeSourceValue : choicedDemandeSource}
              setChoicedDemandeSource={setChoicedDemandeSource}
              transformedSource={transformedSource}
              setTempClientId={setTempClientId}
              isEdit={isEdit}
              demandeId={demandeId}
              setTempClient={setTempClient}
              refRechercheClient={refRechercheClient}
              isPrevious={isPrevious}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              demandeClient={demandeClient}
            />

            {/*Modal création de client*/}
            <AddClientModal
              setClientId={setClientId}
              setOpenModalResVeh={setOpenModalResVeh}
              isCreateViaModal={isCreateViaModal}
              openModalResVeh={openModalResVeh}
            />

            {/*Modal recherche de véhicule*/}
            <ResearchVehicleModal
              clientId={clientId || SelectedClient}
              demandeId={null}
              data={modeleClientDemandeInitValues}
              setClientId={setClientId}
              redirectToClientDemande={redirectToClientDemande}
              defaultValueContact={defaultValueContact}
              isFromAddClientContact={isFromAddClientContact}
              radioValue={radioValue}
              isFromClient={isFromClient}
              demandeSourceValue={demandeSourceValue}
              contactedBy={contactedBy}
              choicedDemandeSource={choicedDemandeSource}
              setChoicedDemandeSource={setChoicedDemandeSource}
              demandeSources={demandeSources}
              sourceLoader={sourceLoader}
              transformedSource={transformedSource}
              contentCommunication={contentCommunication}
              labelSearch={searchTerm}
            />

            {/*Modal choix de contact client*/}
            <ChoixContactModal
              clientId={clientId}
              setDefaultValueContact={setDefaultValueContact}
              defaultValueContact={defaultValueContact}
              isFromAddClientContact={isFromAddClientContact}
              setIsFromAddClientContact={setIsFromAddClientContact}
              setRadioValue={setRadioValue}
              isClientSociety={isClientSociety}
              isFromClientList={false}
              isFromDemandeList={true}
              setContactedBy={setContactedBy}
              radioValue={radioValue}
              setContentCommunication={setContentCommunication}
              contentCommunication={contentCommunication}
              isDuplicate={isDuplicate}
              setIsDuplicate={setIsDuplicate}
              toggleDuplicate={toggleDuplicate}
              isConfirmEdit={isConfirmEdit}
              setIsConfirmEdit={setIsConfirmEdit}
              demandeId={demandeId}
              isEdit={isEdit}
              tempClientId={tempClientId}
              setTempClientId={setTempClientId}
              handleUpdateClientData={handleUpdateClientData}
              setContactedByBloc={setContactedByBloc}
              openChoixContactOnClientChange={openChoixContactOnClientChange}
              clientChangeLoader={clientChangeLoader}
              refRechercheClient={refRechercheClient}
              setIsPrevious={setIsPrevious}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </>
        )}

        {(shouldDisplayFonctionnalite(currentUser, 'VOIR DEMANDE') ||
          shouldDisplayFonctionnalite(currentUser, 'VOIR TOUTE DEMANDE')) && (
          <div
            className='position-relative d-flex flex-column flex-grow-1 gap-2'
            style={{
              minHeight: 0,
              overflow: 'hidden',
            }}
          >
            {data.length > 0 && sortedData[0]?.[0] && (
              <div className='d-flex justify-content-between align-items-center gap-2'>
                {tableRefresh ? (
                  <div className={'mt-2 h-50px'}>
                    <span
                      className={styles.loaderTable}
                      data-tooltip-id='demande-action-tooltip'
                      data-tooltip-content='Rafraichissement des données'
                      data-tooltip-place='bottom'
                    ></span>
                  </div>
                ) : (
                  <div className={'mt-2 h-50px'}>
                    <span className=''></span>
                  </div>
                )}
                <div className={'d-flex align-items-center gap-3'}>
                  <label htmlFor='select-item-per-page'>Demandes par page</label>
                  <select
                    id='select-item-per-page'
                    className='form-control'
                    style={{width: 'auto'}}
                    value={itemPerPage}
                    onChange={(e) => {
                      const value = Number(e.target.value) as 25 | 50 | 100
                      setItemPerPage(value)
                      updateFilter('itemPerPage', value)
                    }}
                  >
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <Pagination
                    totalPages={totalPages}
                    nombreDePages={nombreDePages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    locationState={0}
                  />
                </div>
              </div>
            )}
            <div
              className='table-responsive border border-secondary rounded-1 flex-grow-1'
              style={{
                minHeight: 0,
                height: 0,
                overflowY: 'auto',
                overflowX: 'auto',
                overscrollBehavior: 'contain',
                scrollbarGutter: 'stable',
              }}
            >
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-0'>
                <thead
                  className='sticky-top'
                  style={{
                    zIndex: 10,
                    backgroundColor: '#f8f9fa',
                  }}
                >
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px'>
                      <TableFilter colTitle='Numéro' arrowFilter={false} />
                    </th>
                    <th className='min-w-140px'>
                      <TableFilter
                        colTitle='Assigné'
                        sortFieldValue='ASSIGN'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                        arrowFilter={true}
                      />
                    </th>
                    <th className='min-w-140px'>
                      <TableFilter
                        colTitle='Date'
                        sortFieldValue='DATE'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                        arrowFilter={true}
                      />
                    </th>
                    <th>
                      <TableFilter
                        colTitle='Délai'
                        arrowFilter={true}
                        sortFieldValue='DELAI'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                      />
                    </th>
                    <th className='w-150px'>
                      <TableFilter
                        colTitle='Statut'
                        sortFieldValue='STATUT'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                        arrowFilter={true}
                      />
                    </th>
                    <th>
                      <TableFilter
                        colTitle='Canal'
                        arrowFilter={true}
                        sortFieldValue='CANAL'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                      />
                    </th>
                    {!SelectedClient ? (
                      <th className='min-w-140px'>
                        <TableFilter
                          colTitle='Client'
                          sortFieldValue='CLIENT'
                          setSortField={(key) =>
                            updateFilter('tri', (prevTri) => ({
                              key,
                              order: prevTri?.order ?? 'ASC',
                            }))
                          }
                          setSortOrder={(order) =>
                            updateFilter('tri', (prevTri) => ({
                              key: prevTri?.key,
                              order,
                            }))
                          }
                          sortField={filters?.tri?.key}
                          sortOrder={filters?.tri?.order}
                          arrowFilter={true}
                        />
                      </th>
                    ) : (
                      <th className='min-w-140px align-middle'>Contacté par</th>
                    )}
                    <th className='min-w-100px'>
                      <TableFilter colTitle='Type Client' arrowFilter={false} />
                    </th>
                    <th className='min-w-150px'>
                      <TableFilter
                        colTitle='Groupe Client'
                        sortFieldValue='GRP_CLIENT'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                        arrowFilter={true}
                      />
                    </th>
                    <th className='min-w-140px'>
                      <TableFilter
                        colTitle='Immatriculation'
                        sortFieldValue='IMMAT'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                        arrowFilter={true}
                      />
                    </th>
                    <th className='min-w-140px'>
                      <TableFilter
                        colTitle='Equipe'
                        sortFieldValue='EQUIPE'
                        setSortField={(key) =>
                          updateFilter('tri', (prevTri) => ({
                            key,
                            order: prevTri?.order ?? 'ASC',
                          }))
                        }
                        setSortOrder={(order) =>
                          updateFilter('tri', (prevTri) => ({
                            key: prevTri?.key,
                            order,
                          }))
                        }
                        sortField={filters?.tri?.key}
                        sortOrder={filters?.tri?.order}
                        arrowFilter={true}
                      />
                    </th>
                    {!isFromModalClient && (
                      <th className='min-w-100px'>
                        <TableFilter colTitle='Actions' arrowFilter={false} />
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {data.length && sortedData[0][0] ? (
                    sortedData.map((clientDemande, index) => {
                      const commandes = clientDemande[0]?.commandes ?? []
                      const listPOT =
                        commandes.length > 0
                          ? commandes
                              .flatMap((commande) =>
                                commande?.commandeItems?.map((item) => {
                                  let status = 'A_PROPO'
                                  if (item?.clientDemandePieceProposee?.dateEchec !== null) {
                                    status = 'ECHEC'
                                  } else if (
                                    item?.clientDemandePieceProposee?.isAccepted === true
                                  ) {
                                    status = 'ACCEP'
                                  } else if (
                                    item?.clientDemandePieceProposee?.isAcceptedBlocked === true
                                  ) {
                                    status = 'BLOQU'
                                  } else if (item?.clientDemandePieceProposee?.isRefused === true) {
                                    status = 'REFUS'
                                  }

                                  if (
                                    item?.clientDemandePieceProposee?.isAcceptedBlocked === true
                                  ) {
                                    return {
                                      ...item?.clientDemandePieceProposee?.typePiecePOT,
                                      demande: clientDemande[0],
                                      status: status,
                                    }
                                  }

                                  return undefined
                                })
                              )
                              .filter((item) => item?.id)
                          : []
                      const haveVirement =
                        commandes.filter(
                          (commande) =>
                            commande?.statut === 'BLOQU' &&
                            commande?.codePaiement === 'virement' &&
                            commande?.pot === null
                        ).length > 0

                      const haveBlockedPOT = listPOT.length > 0

                      const displayButton =
                        clientDemande[0].clientDemandeEtape.code === 'BLOQU' &&
                        (haveVirement || haveBlockedPOT)

                      const userCanTraiterDemande =
                        shouldDisplayFonctionnalite(currentUser, 'TRAITER DEMANDE') &&
                        (clientDemande[0]?.utilisateurAssigne?.id === currentUser?.id ||
                          clientDemande[0].clientDemandeEtape.code === 'NOUVE' ||
                          clientDemande[0].clientDemandeEtape.code === 'MODIF')

                      const colorFlag = getDemandeFlagColor(clientDemande[0], delaisTraitement)

                      return (
                        <tr
                          key={clientDemande[0].id}
                          style={{
                            backgroundColor: colorFlag ?? '',
                            pointerEvents: isFromModalClient ? 'none' : 'auto',
                          }}
                          onClick={
                            (userCanTraiterTouteDemande || userCanTraiterDemande ||
                              shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))
                              ? (e) => openDemandeTraitement(clientDemande[0], e)
                                : undefined
                          }
                        >
                          <td>
                            <div className='d-flex align-items-center'>
                              <div className='d-flex justify-content-start flex-column'>
                                {((userCanTraiterTouteDemande || userCanTraiterDemande) ||
                                  (shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))) ? (
                                  <ActionLink
                                    tag={
                                      <p className='text-gray-800 fw-bolder text-hover-primary fs-6 mb-0 teste1'>
                                        {clientDemande[0]?.id}
                                      </p>
                                    }
                                    clientDemande={clientDemande}
                                  />
                                ) : (
                                  <p className='text-gray-800 fw-bolder text-hover-primary fs-6 mb-0 teste2'>
                                    {clientDemande[0]?.id}
                                  </p>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            {((userCanTraiterTouteDemande || userCanTraiterDemande) ||
                              (shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))) ? (
                              <ActionLink
                                tag={
                                  <p className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
                                    {clientDemande[0].utilisateurAssigne?.nom}{' '}
                                    {clientDemande[0].utilisateurAssigne?.prenom}
                                  </p>
                                }
                                clientDemande={clientDemande}
                              />
                            ) : (
                              <p className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
                                {clientDemande[0].utilisateurAssigne?.nom}{' '}
                                {clientDemande[0].utilisateurAssigne?.prenom}
                              </p>
                            )}
                          </td>
                          <td>
                            {((userCanTraiterTouteDemande || userCanTraiterDemande) ||
                              (shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))) ? (
                              <ActionLink
                                tag={
                                  <div className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
                                    <div className='d-flex gap-2'>
                                      <IconCalendar />
                                      {moment(clientDemande[0].dateCreation).format(
                                        'DD/MM/YYYY HH:mm'
                                      )}
                                    </div>
                                  </div>
                                }
                                clientDemande={clientDemande}
                              />
                            ) : (
                              <div className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
                                <div className='d-flex gap-2'>
                                  <IconCalendar />
                                  {moment(clientDemande[0].dateCreation).format('DD/MM/YYYY HH:mm')}
                                </div>
                              </div>
                            )}
                          </td>
                          <td>
                            {((userCanTraiterTouteDemande || userCanTraiterDemande) ||
                              (shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))) ? (
                              <ActionLink
                                tag={
                                  <p className='text-gray-800 fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {renderTempsEcoule(clientDemande[0])}
                                  </p>
                                }
                                clientDemande={clientDemande}
                              />
                            ) : (
                              <p className='text-gray-800 fw-bold text-hover-primary d-block fs-6 mb-0'>
                                {renderTempsEcoule(clientDemande[0])}
                              </p>
                            )}
                          </td>
                          <td>
                            {((userCanTraiterTouteDemande || userCanTraiterDemande) ||
                              (shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))) ? (
                              <ActionLink
                                tag={
                                  <p className='text-gray-800 fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {renderStatut(
                                      clientDemande[0].clientDemandeEtape,
                                      clientDemande[0]?.intervention,
                                      true
                                    )}
                                    {/*{(() => {*/}
                                    {/*  const code = clientDemande[0].clientDemandeEtape?.code*/}

                                    {/*  let notAvalaible = 0*/}

                                    {/*  const pieces = clientDemande[0]?.pieces || []*/}

                                    {/*  if (code === 'ASSIG') {*/}
                                    {/*    let aProposerCount = 0*/}

                                    {/*    pieces.forEach((piece) => {*/}
                                    {/*      if (piece?.statut === 'NON_DISPONIBLE') {*/}
                                    {/*        notAvalaible++*/}
                                    {/*      }*/}

                                    {/*      if (piece.clientDemandePieceProposee?.length > 0) {*/}
                                    {/*        piece.clientDemandePieceProposee.forEach((propo) => {*/}
                                    {/*          if (!propo.isProposed) {*/}
                                    {/*            aProposerCount++*/}
                                    {/*          }*/}
                                    {/*        })*/}
                                    {/*      }*/}
                                    {/*    })*/}
                                    {/*    return (*/}
                                    {/*      <>*/}
                                    {/*        {aProposerCount > 0 && (*/}
                                    {/*          <>*/}
                                    {/*            <span*/}
                                    {/*              className='badge badge-secondary'*/}
                                    {/*              style={{*/}
                                    {/*                marginBlock: '2px',*/}
                                    {/*              }}*/}
                                    {/*            >*/}
                                    {/*              À proposer ({aProposerCount})*/}
                                    {/*            </span>*/}

                                    {/*            <br />*/}
                                    {/*          </>*/}
                                    {/*        )}*/}

                                    {/*        {notAvalaible > 0 ? (*/}
                                    {/*          <span className='badge badge-info'>*/}
                                    {/*            Non disponible ({notAvalaible})*/}
                                    {/*          </span>*/}
                                    {/*        ) : (*/}
                                    {/*          renderStatut(*/}
                                    {/*            clientDemande[0].clientDemandeEtape,*/}
                                    {/*            clientDemande[0]?.intervention*/}
                                    {/*          )*/}
                                    {/*        )}*/}
                                    {/*      </>*/}
                                    {/*    )*/}
                                    {/*  }*/}
                                    {/*  if (*/}
                                    {/*    code !== 'ACCEP' &&*/}
                                    {/*    code !== 'REFUS' &&*/}
                                    {/*    code !== 'PROPO' &&*/}
                                    {/*    code !== 'BLOQU' &&*/}
                                    {/*    code !== 'ECHEC'*/}
                                    {/*  ) {*/}
                                    {/*    return renderStatut(*/}
                                    {/*      clientDemande[0].clientDemandeEtape,*/}
                                    {/*      clientDemande[0]?.intervention*/}
                                    {/*    )*/}
                                    {/*  }*/}
                                    {/*  let acceptedCount = 0*/}
                                    {/*  let refusedCount = 0*/}
                                    {/*  let proposee = 0*/}
                                    {/*  let accepteeBloquee = 0*/}
                                    {/*  let annulee = 0*/}
                                    {/*  let aProposerCount = 0*/}
                                    {/*  let echec = 0*/}

                                    {/*  pieces.forEach((piece) => {*/}
                                    {/*    const demandeProposee =*/}
                                    {/*      piece?.clientDemandePieceProposee || []*/}

                                    {/*    if (piece?.statut === 'NON_DISPONIBLE') {*/}
                                    {/*      notAvalaible++*/}
                                    {/*    }*/}

                                    {/*    demandeProposee.forEach((propo) => {*/}
                                    {/*      if (propo.isProposed) {*/}
                                    {/*        if (propo?.isAccepted) {*/}
                                    {/*          acceptedCount++*/}
                                    {/*        } else if (propo?.isRefused) {*/}
                                    {/*          refusedCount++*/}
                                    {/*        } else if (propo?.isAcceptedBlocked) {*/}
                                    {/*          accepteeBloquee++*/}
                                    {/*        } else if (propo?.dateAnnulation != null) {*/}
                                    {/*          annulee++*/}
                                    {/*        } else if (propo?.dateEchec != null) {*/}
                                    {/*          echec++*/}
                                    {/*        } else {*/}
                                    {/*          proposee++*/}
                                    {/*        }*/}
                                    {/*      } else {*/}
                                    {/*        aProposerCount++*/}
                                    {/*      }*/}
                                    {/*    })*/}
                                    {/*  })*/}

                                    {/*  return (*/}
                                    {/*    <>*/}
                                    {/*      {acceptedCount > 0 && (*/}
                                    {/*        <>*/}
                                    {/*          <span*/}
                                    {/*            className='badge badge-light-success'*/}
                                    {/*            style={{*/}
                                    {/*              marginBlock: '2px',*/}
                                    {/*            }}*/}
                                    {/*          >*/}
                                    {/*            Acceptée ({acceptedCount})*/}
                                    {/*          </span>*/}

                                    {/*          <br />*/}
                                    {/*        </>*/}
                                    {/*      )}*/}

                                    {/*      {refusedCount > 0 && (*/}
                                    {/*        <>*/}
                                    {/*          <span*/}
                                    {/*            className='badge badge-light-danger'*/}
                                    {/*            style={{*/}
                                    {/*              marginBlock: '2px',*/}
                                    {/*            }}*/}
                                    {/*          >*/}
                                    {/*            Refusée ({refusedCount})*/}
                                    {/*          </span>*/}

                                    {/*          <br />*/}
                                    {/*        </>*/}
                                    {/*      )}*/}

                                    {/*      {proposee > 0 && (*/}
                                    {/*        <>*/}
                                    {/*          <span*/}
                                    {/*            className='badge badge-info'*/}
                                    {/*            style={{*/}
                                    {/*              marginBlock: '2px',*/}
                                    {/*            }}*/}
                                    {/*          >*/}
                                    {/*            Proposée ({proposee})*/}
                                    {/*          </span>*/}

                                    {/*          <br />*/}
                                    {/*        </>*/}
                                    {/*      )}*/}

                                    {/*      {aProposerCount > 0 && (*/}
                                    {/*        <>*/}
                                    {/*          <span*/}
                                    {/*            className='badge badge-secondary'*/}
                                    {/*            style={{*/}
                                    {/*              marginBlock: '2px',*/}
                                    {/*            }}*/}
                                    {/*          >*/}
                                    {/*            À proposer ({aProposerCount})*/}
                                    {/*          </span>*/}

                                    {/*          <br />*/}
                                    {/*        </>*/}
                                    {/*      )}*/}

                                    {/*      {notAvalaible > 0 && (*/}
                                    {/*        <>*/}
                                    {/*          <span*/}
                                    {/*            className='badge badge-info'*/}
                                    {/*            style={{*/}
                                    {/*              marginBlock: '2px',*/}
                                    {/*            }}*/}
                                    {/*          >*/}
                                    {/*            Non disponible ({notAvalaible})*/}
                                    {/*          </span>*/}

                                    {/*          <br />*/}
                                    {/*        </>*/}
                                    {/*      )}*/}

                                    {/*      {annulee > 0 && (*/}
                                    {/*        <>*/}
                                    {/*          <span*/}
                                    {/*            className='badge badge-light'*/}
                                    {/*            style={{*/}
                                    {/*              marginBlock: '2px',*/}
                                    {/*            }}*/}
                                    {/*          >*/}
                                    {/*            Annulée ({annulee})*/}
                                    {/*          </span>*/}

                                    {/*          <br />*/}
                                    {/*        </>*/}
                                    {/*      )}*/}

                                    {/*      {accepteeBloquee > 0 && (*/}
                                    {/*        <span*/}
                                    {/*          className='badge badge-danger'*/}
                                    {/*          style={{*/}
                                    {/*            marginBlock: '2px',*/}
                                    {/*          }}*/}
                                    {/*        >*/}
                                    {/*          Acceptée bloquée ({accepteeBloquee})*/}
                                    {/*        </span>*/}
                                    {/*      )}*/}

                                    {/*      {echec > 0 && (*/}
                                    {/*        <span*/}
                                    {/*          className='badge badge-light-warning-echec'*/}
                                    {/*          style={{*/}
                                    {/*            marginBlock: '2px',*/}
                                    {/*          }}*/}
                                    {/*        >*/}
                                    {/*          Acceptée Indisponible ({echec})*/}
                                    {/*        </span>*/}
                                    {/*      )}*/}

                                    {/*      {clientDemande[0]?.intervention &&*/}
                                    {/*        renderStatut(*/}
                                    {/*          clientDemande[0].clientDemandeEtape,*/}
                                    {/*          clientDemande[0]?.intervention*/}
                                    {/*        )}*/}
                                    {/*    </>*/}
                                    {/*  )*/}
                                    {/*})()}*/}
                                  </p>
                                }
                                clientDemande={clientDemande}
                              />
                            ) : (
                              <p className='text-gray-800 fw-bold text-hover-primary d-block fs-6 mb-0'>
                                {renderStatut(
                                  clientDemande[0].clientDemandeEtape,
                                  clientDemande[0]?.intervention,
                                  true
                                )}
                              </p>
                            )}
                          </td>
                          <td className='text-center'>
                            {((userCanTraiterTouteDemande || userCanTraiterDemande) ||
                              (shouldDisplayFonctionnalite(currentUser, 'AJOUTER ACTION'))) ? (
                              <ActionLink
                                tag={renderIconSource(
                                  clientDemande[0]?.demandeSource?.id,
                                  true,
                                  false,
                                  false
                                )}
                                clientDemande={clientDemande}
                              />
                            ) : (
                              renderIconSource(
                                clientDemande[0]?.demandeSource?.id,
                                true,
                                false,
                                false
                              )
                            )}
                          </td>
                          {!SelectedClient ? (
                            <td>
                              <div className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
                                {clientDemande[0].client?.professionnel
                                  ? clientDemande[0].client?.nomSociete
                                  : clientDemande[0].client?.nom +
                                    ' ' +
                                    clientDemande[0].client?.prenom}
                              </div>
                              {/*<span className='text-muted fw-semibold d-block fs-7'>*/}
                              {/*  {clientDemande[0]?.contactedBy?.email ??*/}
                              {/*    clientDemande[0]?.contactedBy?.telephone ??*/}
                              {/*    clientDemande[0]?.contactedBy?.mobile ??*/}
                              {/*    ''}*/}
                              {/*</span>*/}
                            </td>
                          ) : (
                            <td>
                              {clientDemande[0].contactedBy?.email?.trim() ||
                                clientDemande[0].contactedBy?.telephone?.trim() ||
                                clientDemande[0].contactedBy?.mobile?.trim() ||
                                ''}
                            </td>
                          )}
                          <td>
                            <div className='d-flex justify-content-center align-items-center'>
                              <div>
                                {/*{clientDemande[0]?.client?.typeClient && (*/}
                                {/*  <>*/}
                                {/*  <span*/}
                                {/*    className={*/}
                                {/*      clientDemande[0]?.client?.typeClient == 'PROSPECT'*/}
                                {/*        ? `fw-bolder px-4 badge mb-1 badge-prosp`*/}
                                {/*        : `fw-bolder px-9 badge mb-1 badge-light-primary`*/}
                                {/*    }*/}
                                {/*  >*/}
                                {/*    {clientDemande[0]?.client?.typeClient}*/}
                                {/*  </span>*/}
                                {/*    <br />*/}
                                {/*  </>*/}
                                {/*)}*/}
                                {clientDemande[0]?.client?.professionnel ? (
                                  <span className='badge badge-prof fw-bolder me-auto px-4'>
                                    PRO
                                  </span>
                                ) : (
                                  <span className='badge badge-part fw-bolder me-auto px-4'>
                                    PART
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className='text-gray-800 text-hover-primary d-block text-center fs-6 mb-0'>
                              {clientDemande?.groupeClient ?? ''}
                            </div>
                          </td>
                          <td>
                            {clientDemande['immatriculation']?.split(',').map((item, index) => (
                              <InfoLigne
                                key={`immat-${index}`}
                                value={item}
                                pieces={clientDemande[0]?.pieces || []}
                                type='immat'
                                marque=''
                                index={index}
                              />
                            ))}

                            {clientDemande['modele']?.split(',').map((item, index) => (
                              <InfoLigne
                                key={`modele-${index}`}
                                value={item}
                                pieces={clientDemande[0]?.pieces || []}
                                type='modele'
                                marque=''
                                index={index}
                              />
                            ))}
                            {clientDemande['modeleVht']?.split(',').map((item, index) => (
                              <InfoLigne
                                key={`modelevht-${index}`}
                                value={item}
                                pieces={clientDemande[0]?.pieces || []}
                                type='modeleVht'
                                marque={clientDemande.marqueVht}
                                index={index}
                              />
                            ))}
                          </td>
                          <td>
                            <div className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
                              {clientDemande[0]?.equipe?.nom}
                            </div>
                          </td>
                          {!isFromModalClient && (
                            <td onClick={(e) => e.stopPropagation()}>
                              <div className='d-flex justify-content-start column-gap-2'>
                                {clientDemande['clientDemandeMessage'] !== null &&
                                  clientDemande['clientDemandeMessage'] !== undefined && (
                                    <ClientDemandeMessage
                                      demandeId={clientDemande[0].id}
                                      readOnly={true}
                                      trigger={trigger}
                                    />
                                  )}
                                {displayButton && (
                                  <span
                                    className='btn btn-icon btn-bg-light btn-sm'
                                    data-bs-toggle={
                                      haveVirement || haveBlockedPOT ? 'modal' : undefined
                                    }
                                    data-bs-target={
                                      haveVirement
                                        ? '#confirmBVModal'
                                        : haveBlockedPOT
                                        ? '#modalPOT'
                                        : undefined
                                    }
                                    data-bs-dismiss={
                                      haveVirement || haveBlockedPOT ? 'modal' : undefined
                                    }
                                    onClick={() => {
                                      if (haveVirement) {
                                        handleModalVB(clientDemande[0])
                                      }

                                      if (haveBlockedPOT) {
                                        setSelectedPOTAriane(listPOT?.[0] ?? null)
                                      }

                                      setListePOTAriane(listPOT)
                                      setCommandeAriane(commandes)
                                    }}
                                    data-tooltip-id='demande-action-tooltip'
                                    data-tooltip-content='Modifier le statut de cette commande bloquée'
                                    data-tooltip-place='left'
                                  >
                                    <i className='bi bi-bank2 fs-2 cursor-pointer' />
                                  </span>
                                )}
                                {(userCanTraiterTouteDemande || userCanTraiterDemande) && (
                                  <>
                                    <ActionLink
                                      tag={
                                        <img
                                          src='/media/svg/custom/File add.svg'
                                          width='25'
                                          alt='File add'
                                        />
                                      }
                                      clientDemande={clientDemande}
                                      isBtn={true}
                                    />

                                    {clientDemande.isProposed === 1 && (
                                      <span
                                        className='btn btn-icon btn-bg-light btn-sm'
                                        data-tooltip-id='demande-action-tooltip'
                                        data-tooltip-content='Voir le panier'
                                        data-tooltip-place='left'
                                      >
                                        <i
                                          className='bi bi-cart fs-2'
                                          style={{
                                            color: editHover === index ? '#9AC331' : '',
                                            transition: 'color 0.3s ease',
                                          }}
                                          onClick={() => handlePanier(clientDemande[0])}
                                        />
                                      </span>
                                    )}
                                  </>
                                )}
                                {(clientDemande[0].clientDemandeEtape.code === 'NOUVE' ||
                                  clientDemande[0].clientDemandeEtape.code === 'ASSIG' ||
                                  clientDemande[0].clientDemandeEtape.code === 'MODIF' ||
                                  clientDemande[0].clientDemandeEtape.code === 'PROPO') && (
                                  <span
                                    className={`btn btn-icon btn-bg-light btn-sm ${
                                      shouldDisplayFonctionnalite(currentUser, 'MODIFIER DEMANDE')
                                        ? ''
                                        : 'invisible'
                                    }`}
                                  >
                                    <Link
                                      to={`/demandes/${clientDemande[0].client.id}/edit/${clientDemande[0].id}`}
                                      state={{
                                        demandeId: clientDemande[0].id,
                                        immat: [],
                                        isFromClient: isFromClient,
                                        redirectToClientDemande: redirectToClientDemande,
                                        filters: filters,
                                        isClientSociety: isClientSociety,
                                        defaultValueContact: defaultValueContact,
                                        transformedSource: transformedSource,
                                        contactedBy: contactedBy,
                                        contentCommunication: contentCommunication,
                                        isDuplicate: isDuplicate,
                                        radioValue: radioValue,
                                        clientDemandeStatus:
                                          clientDemande?.[0]?.clientDemandeEtape?.code ?? '',
                                      }}
                                      data-tooltip-id='demande-action-tooltip'
                                      data-tooltip-content='Modifier la demande'
                                      data-tooltip-place='left'
                                    >
                                      <i
                                        className='ki-duotone ki-pencil fs-2x'
                                        style={{
                                          color: editHover === index ? '#ffcd3f' : '',
                                          transition: 'color 0.3s ease',
                                        }}
                                        onMouseEnter={() => setEditHover(index)}
                                        onMouseLeave={() => setEditHover(null)}
                                      >
                                        <span className='path1' />
                                        <span className='path2' />
                                      </i>
                                    </Link>
                                  </span>
                                )}
                                {(clientDemande[0].clientDemandeEtape.code === 'NOUVE' ||
                                  clientDemande[0].clientDemandeEtape.code === 'ASSIG' ||
                                  clientDemande[0].clientDemandeEtape.code === 'MODIF') && (
                                  <span
                                    className={`btn btn-icon btn-bg-light btn-sm ${
                                      shouldDisplayFonctionnalite(currentUser, 'SUPPRIMER DEMANDE')
                                        ? ''
                                        : 'd-none'
                                    }`}
                                    data-tooltip-id='demande-action-tooltip'
                                    data-tooltip-content='Supprimer la demande'
                                    data-tooltip-place='left'
                                  >
                                    <i
                                      className='ki-duotone ki-trash fs-2x'
                                      onClick={() => handleDemandeDelete(clientDemande[0].id)}
                                      style={{
                                        color: deleteHover === index ? '#f1416c' : '',
                                        transition: 'color 0.3s ease',
                                      }}
                                      onMouseEnter={() => setDeleteHover(index)}
                                      onMouseLeave={() => setDeleteHover(null)}
                                    >
                                      <span className='path1' />
                                      <span className='path2' />
                                      <span className='path3' />
                                      <span className='path4' />
                                      <span className='path5' />
                                    </i>
                                  </span>
                                )}
                                <span
                                  className='btn btn-icon btn-bg-light btn-sm'
                                  data-tooltip-id='demande-action-tooltip'
                                  data-tooltip-content='Dupliquer la demande'
                                  data-tooltip-place='left'
                                >
                                  <i
                                    className='bi bi-copy fs-2'
                                    onClick={() => handleDuplicate(clientDemande)}
                                  >
                                    <span className='path1' />
                                  </i>
                                </span>
                              </div>
                            </td>
                          )}
                        </tr>
                      )
                    })
                  ) : tableRefresh ? (
                    <tr>
                      <td
                        colSpan={12}
                        className='p-4 text-center'
                        style={{
                          height: '300px',
                        }}
                      >
                        <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px' />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td
                        colSpan={12}
                        className='text-center'
                        style={{
                          height: '100px',
                        }}
                      >
                        Aucune demande client trouvée
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Tooltip id='demande-action-tooltip' positionStrategy='fixed' />
          </div>
        )}
      </div>

      {/* ============================================================= */}
      {/* MODALS                                                        */}
      {/* ============================================================= */}

      {openActionModal && (
        <ViewActionModal
          show={openActionModal}
          showModal={toggleShowActionModal}
          dataActions={dataActions}
          setDataActions={setDataActions}
          onSelectDemande={handleSelectDemande}
        />
      )}

      <ShopModal
        clientId={clientId}
        demandeId={demandeId}
        handleDismiss={handleDismiss}
        panierFiltered={handlePanierFiltered}
        panier={panier}
        setPanier={setPanier}
        setDemandeClient={setDemandeClient}
        pieces={pieces}
        setPieces={setPieces}
        dataClientInfos={dataClientInfos}
        loadingCLientInfo={loadingCLientInfo}
        otherData={otherData}
        isProspect={isProspect}
        redirectDemandeListPage={redirectDemandeListPage}
        loadingPanier={loadingPanier}
        setPiecesProps={setPieces}
        displayBasketBtn={false}
        filters={filters}
        provenances={provenances}
        fromListDemande={true}
        clientDemandeStatus={clientDemandeStatus}
        isAdresseUpdated={isAdresseUpdated}
        setIsAdresseUpdated={setIsAdresseUpdated}
        updatedFinalAdresseLivInfo={updatedFinalAdresseLivInfo}
        setUpdatedFinalAdresseLivInfo={setUpdatedFinalAdresseLivInfo}
        updatedFinalAdresseFactInfo={updatedFinalAdresseFactInfo}
        setUpdatedFinalAdresseFactInfo={setUpdatedFinalAdresseFactInfo}
        errorsFac={errorsFac}
        setErrorsFac={setErrorsFac}
        errorsLiv={errorsLiv}
        setErrorsLIv={setErrorsLIv}
        requierdFieldFac={requierdFieldFac}
        requierdFieldLiv={requierdFieldLiv}
        isConfirmEdit={true}
        contactedBy={contactedBy}
        demandeClient={demandeClient}
        setIsEdit={setIsEdit}
        contactedByBloc={contactedByBloc}
        setContactedByBloc={setContactedByBloc}
        piecePropData={piecePropData}
        groupeClientLoader={groupeClientLoader}
        retraitDepot={retraitDepot}
        setRetraitDepot={setRetraitDepot}
        checkedPieces={checkedPieces}
        setCheckedPieces={setCheckedPieces}
        totalLibelle={totalLibelle}
        setTotalLibelle={setTotalLibelle}
        adresseDepots={adresseDepots}
        loadingDepot={loadingDepot}
        getAdresseRetraitDepot={getAdresseRetraitDepot}
        initialPieces={initialPieces}
        commentaireInterne={commentaireInterne}
        setCommentaireInterne={setCommentaireInterne}
        setIsEditPanier={setIsEditPanier}
        livraisonSelectedValue={livraisonSelectedValue}
        setLivraisonSelectedValue={setLivraisonSelectedValue}
        facturationSelectedValue={facturationSelectedValue}
        setFacturationSelectedValue={setFacturationSelectedValue}
        getDemandeProp={getDemandeProposition}
      />

      <ConfirmVBModal demande={demandeVB} handleList={handleList} />

      <ModalPOT
        piece={selectedPOTAriane}
        setPanier={setPanier}
        showToastPOT={showToastPOT}
        provenances={provenances}
        listDemande={data}
        setListDemande={setData}
        isEdit={true}
        isEditPanier={isEditPanier}
        setIsEditPanier={setIsEditPanier}
      />

      <button
        type='button'
        ref={refChoiceVehicle}
        className='btn btn-light-info d-none'
        data-bs-target='#choixContactModal'
        data-bs-toggle='modal'
        data-bs-dismiss='modal'
      >
        Retour
      </button>
    </>
  )
}

export {DemandListPage}
